<template>
    <main>
        <div class="J-chat-container J-conversation">
            <div class="J-chat-avatar-content">
                <a href="javascript:void(0)" @click="isTabActive(1)" class="J-icon-back">
                    <i class="fas fa-angle-left"></i>
                </a>
                <v-avatar>
                    <img :src="conversation_avatar" alt="Avatar">
                </v-avatar>
                <div class="J-chat-message-content">
                    <div class="J-chat-name">
                        <span>
                           {{data_conversation.name}}
                        </span>
                    </div>
                    <div class="J-chat-date">
                        <span>
                            {{data_conversation.session}}
                        </span>
                    </div>
                </div>
            </div>
            <div class="J-chat-convesation-content">
                <div class="J-chat-conversation scrollmenucompany" id="messages_content">
                    <div class="J-user-conversation" v-for="(message,index) in message_data" :key="index+1" :class="{'J-user-response':message.id_user==identity._id}">
                        <div class="J-user-avatar" style="margin-top:3px">
                            <v-avatar size="36px">
                                <img :src="message.avatar" alt="Avatar">
                            </v-avatar>
                        </div>
                        <div class="J-chat-message">
                            <span>
                                {{message.message}}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="J-chat-response">
                    <div class="J-chat-form">
                        <form @submit.prevent="sendMessage()">
                            <input required class="form-control J-chat-input" v-model="txt_message" placeholder="Mensaje...">
                            <button class="btn J-chat-btn" type="submit">Enviar</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>
<script>
    import initVue from '../../../../helpers/initVue'
    import {mapGetters} from 'vuex'
    import moment from 'moment'
    import {UsersStorage} from '@/helpers/storage.js'

    moment.locale('es');
    export default {
        computed: mapGetters({
            indetityU: 'getIdentity',
            tokenU: 'getToken'
        }),
        data(){
            return{
                conversation_avatar:'https://cdn.vuetifyjs.com/images/cards/foster.jpg',
                id_conversation:null,
                identity:null,
                token:null,
                usersStorage:new UsersStorage(),
                session:null,
                txt_message:null,
                id_user:null,
                message_data:[
                ],
                user:null,
            }
        },
        props:{
            data_conversation:null,
            is_company:false,
            my_data:null,
        },
        sockets:{
            message_new(data){
                if(data.id!=this.id_conversation){
                    //console.log(data,this.id_conversation)
                    return;
                }
                var message={
                    id_user:data.message.id_user,
                    message:data.message.message,
                    avatar:data.message.avatar,
                };
                this.message_data.push(message);
                this.barScrollMessage();
            },
        },
        created(){
            this.getidentity();
            this.id_conversation=this.data_conversation.id;
            if(!this.is_company){
                if(this.data_conversation.image_company){
                    this.conversation_avatar=this.data_conversation.image_company[0].link;
                }
            }
            else{
                this.id_user=this.my_data._id;
                this.id_conversation=this.data_conversation.id;
                this.conversation_avatar=this.data_conversation.avatar[0].link;
            }
            this.getMessages();
            this.viewMessage();
        },
        methods:{
            viewMessage:function(){
                var data={
                    id:this.id_user,
                    token:this.token,
                    view:{
                        id_user:this.identity._id,
                        id_conversation:this.id_conversation,
                    }
                }
                this.$socket.emit('view_message',data);
              
            },
            isTabActive:async function(){
                this.$emit('back',1);
            },
            getMessages:async function(){
                this.getSession();
                await axios.get(`/user/list-message/${this.id_conversation}/${this.id_user}`)
                .then(res=>{
                    const {data}=res.data;
                    var newData=[];
                    data.chats[0].conversation.forEach(element => {
                        if(element._id_user!=null){
                            newData.push({
                                id_user:element._id_user._id,
                                message:element.message,
                                avatar:element._id_user.photo[0].link,
                                name:element._id_user.fullname,
                            })
                        }
                    });
                    this.message_data=newData;
                    
                })
                .catch(err=>{
                    
                })
                this.barScrollMessage();
            },
            getidentity:function(){
                this.identity = initVue.getIdentity().identity
                this.token = initVue.getIdentity().token
                this.session = initVue.isLogged(this.identity, this.token)
                this.id_user=this.identity._id;
                var storageuser=localStorage.getItem('user');
                if(storageuser!=null){
                    storageuser=JSON.parse(storageuser);
                     var user={
                        name:storageuser.fullname,
                        avatar:storageuser.photo,
                    }
                    this.user=user;
                }
               
            },
            getSession:async function(){
                var session=await axios.get(`/users/session/${this.id_conversation}`);
                const {data}=session.data;
                if(data.history[0].description=='active'){
                    this.data_conversation.session='Activo ahora'
                    
                }
                else if(data.history[0].description=='inactive'){
                    var date=moment(data.history[0].created_at).fromNow();
                    this.data_conversation.session=`Activo ${date}`;
                }

            },
            sendMessage:async function(){
                var data={
                    id:this.id_user,
                    token:this.token,
                    message:{
                        name:this.usersStorage.get().fullname||'anonimo',
                        id_user:this.identity._id,
                        id_conversation:this.id_conversation,
                        message:this.txt_message,
                        avatar:this.user.avatar,
                    }
                }
                this.$socket.emit('message',data);
                var message={
                    id_user:this.identity._id,
                    message:this.txt_message,
                    avatar:this.user.avatar,
                };
                this.message_data.push(message);
                this.txt_message=null;

                this.barScrollMessage();
                
            },
            barScrollMessage:function(){
               if(screen.width>768){
                   this.barScrollBottom();
               }
               else{
                   this.barScrollTop()
               }
            },
            barScrollBottom:function(){
                setTimeout(function(){
                    var scroll=document.getElementById('messages_content');
                    scroll.scrollTop=scroll.scrollHeight;
                },10)
            },
            barScrollTop:function(){
                setTimeout(function(){
                    var scroll=document.getElementById('messages_content');
                    scroll.scrollTop=0;
                },10)
            }
        }
    }
</script>
